export { PageHeader } from "@/components/ui/PageHeader";
export type { PageHeaderProps } from "@/components/ui/PageHeader";
